import React from "react";
import PropTypes from "prop-types";
import Autosuggest from "react-autosuggest";
import classNames from "classnames";

import "./auto-suggest.scss";

const defaultRenderSuggestion = suggestion => (
  <div className="autocomplete-search__suggestion">{suggestion}</div>
);

const AutoSuggest = ({
  className,
  id,
  suggestions,
  onSuggestionsFetchRequested,
  onSuggestionsClearRequested,
  getSuggestionValue,
  inputProps,
  renderSuggestion = defaultRenderSuggestion,
}) => {
  const classes = classNames("autocomplete-search", className);

  return (
    <div className={classes}>
      <Autosuggest
        id={id}
        suggestions={suggestions}
        onSuggestionsFetchRequested={onSuggestionsFetchRequested}
        onSuggestionsClearRequested={onSuggestionsClearRequested}
        getSuggestionValue={getSuggestionValue}
        inputProps={inputProps}
        renderSuggestion={renderSuggestion}
      />
    </div>
  );
};

AutoSuggest.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  inputProps: PropTypes.shape({
    id: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
  }).isRequired,
  suggestions: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string]))
    .isRequired,
  onSuggestionsFetchRequested: PropTypes.func.isRequired,
  onSuggestionsClearRequested: PropTypes.func.isRequired,
  getSuggestionValue: PropTypes.func.isRequired,
  renderSuggestion: PropTypes.func,
};

export default AutoSuggest;
